import React, { useEffect, useState } from "react";
import { StyledShopName, StyledTopPart } from "../Catalog/styled";
import {
  Avatar,
  Button,
  Divider,
  Grid,
  IconButton,
  Slider,
  SvgIcon,
  Typography,
} from "@mui/material";
import {
  ArrowBack,
  ArrowForward,
  ConfirmationNumberOutlined,
  FavoriteBorder,
  HelpOutlineOutlined,
  InfoOutlined,
  NavigateBefore,
  NotificationsNoneOutlined,
  Storefront,
} from "@mui/icons-material";
import { colors } from "../../theme/colors";
import { useNavigate } from "react-router-dom";
import { ProductWrapper } from "../Shop/styled";
import {
  getInitials,
  sortArrayOfObjectsByProperty,
} from "../../utils/functions";
import {
  StyledCardAmount,
  StyledProductWrapper,
  StyledTitle,
} from "../Buy/styled";
import { ReactComponent as NotificationIcon } from "../../assets/svg/notification-active.svg";
import { ReactComponent as TicketIcon } from "../../assets/svg/ticket2-default.svg";
import { ReactComponent as HeartIcon } from "../../assets/svg/Trazado 19268.svg";

export default function FixedVoucher({ product }) {
  const navigate = useNavigate();
  const [buttonHover, setButtonHover] = useState(false);
  const [selectedVoucherIndex, setSelectedVoucherIndex] = useState(0);
  const [sortedProducts, setSortedProducts] = useState(
    product.sort(sortArrayOfObjectsByProperty)
  );

  return (
    <>
      <div style={{ maxWidth: "85%", margin: "auto" }}>
        {/* <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} /> */}

        <StyledTitle style={{ color: colors.primary, marginTop: "2rem" }}>
          {product.length === 1 ? "Monto" : "Elige el monto"}
        </StyledTitle>

        <StyledProductWrapper container direction="column">
          <Grid item>
            <Grid container textAlign="start">
              <Grid item md={4} textAlign="start">
                {sortedProducts[selectedVoucherIndex].brandImage ? (
                  <Avatar
                    sx={{
                      width: 80,
                      height: 80,
                      margin: "0.5rem",
                      "@media screen and (max-width: 600px)": {
                        width: 40,
                        height: 40,
                      },
                    }}
                    src={sortedProducts[selectedVoucherIndex].brandImage}
                  />
                ) : (
                  <StyledShopName
                    style={{
                      width: 80,
                      height: 80,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0.5rem auto auto 0.5rem",
                    }}
                  >
                    <span>
                      {getInitials(
                        sortedProducts[selectedVoucherIndex].partner
                      )}
                    </span>
                  </StyledShopName>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            <>
              <StyledCardAmount>
                {"Q "}
                {sortedProducts[selectedVoucherIndex].price}
              </StyledCardAmount>
            </>
          </Grid>
        </StyledProductWrapper>
      </div>

      {sortedProducts.length > 1 && (
        <Grid
          style={{
            color: colors.secondary,
            textTransform: "capitalize",
            textAlign: "center",
            fontSize: "22px",
          }}
          container
          spacing={3}
          justifyContent="center"
          direction={"column"}
        >
          <Grid item sx={{ textTransform: "none" }}>
            Desliza el monto deseado
          </Grid>
          <Grid item>
            <div style={{ maxWidth: "374px", width: "80%", margin: "auto" }}>
              <Slider
                min={0}
                max={sortedProducts.length - 1}
                valueLabelDisplay="auto"
                valueLabelFormat={(v) => `Q ${sortedProducts[v].price}`}
                color="secondary"
                onChange={(e) => setSelectedVoucherIndex(e.target.value)}
                marks={true}
              />
              <Grid
                container
                sx={{
                  justifyContent: {
                    xs: "space-around",
                    md: "space-between",
                  },
                }}
              >
                <Grid
                  item
                  sx={{
                    transform: {
                      xs: "translateX(-100%)",
                      md: "translateX(-50%)",
                    },
                  }}
                >
                  <Typography
                    color="primary"
                    fontWeight="bold"
                    variant="h5"
                  >{`Q${sortedProducts[0].price}`}</Typography>
                </Grid>
                <Grid
                  item
                  sx={{
                    transform: {
                      xs: "translateX(100%)",
                      md: "translateX(50%)",
                    },
                  }}
                >
                  <Typography
                    color="primary"
                    fontWeight="bold"
                    variant="h5"
                  >{`Q${
                    sortedProducts[sortedProducts.length - 1].price
                  }`}</Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      )}

      <div
        style={{
          maxWidth: "560px",
          margin: "0rem auto 0rem auto",
          textAlign: "center",
        }}
      >
        <Divider />
        <Typography color="secondary" variant="h4" fontWeight="regular">
          <Grid container spacing={5} justifyContent="center">
            <Grid item>TOTAL A PAGAR</Grid>
            <Grid item>
              <strong>{`Q ${sortedProducts[selectedVoucherIndex].price}`}</strong>
            </Grid>
          </Grid>
        </Typography>
      </div>

      <Button
        endIcon={buttonHover ? <ArrowForward color="secondary" /> : null}
        onMouseOver={() => setButtonHover(true)}
        onMouseOut={() => setButtonHover(false)}
        color={buttonHover ? "primary" : "secondary"}
        variant="contained"
        onClick={() => {
          window.scrollTo(0, 0);
          navigate(`../buy/${sortedProducts[selectedVoucherIndex].voucherId}`);
        }}
        sx={{
          left: "50%",
          transform: "translateX(-50%)",
          width: "60%",
          paddingRight: buttonHover ? "10%" : "initial",
          transition: "padding 200ms",
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem",
          marginTop: "1.5rem",
          maxWidth: "650px",
          "@media screen and (max-width: 450px)": {
            width: "85%",
          },
        }}
      >
        Siguiente
      </Button>

      <Grid
        container
        spacing={2}
        sx={{ width: "85%", margin: "auto", marginTop: "3rem" }}
        justifyContent="center"
      >
        {sortedProducts[selectedVoucherIndex].description && (
          <Grid
            item
            alignItems="center"
            gap={2}
            sm={8}
            md={8}
            lg={4}
            textAlign="start"
          >
            <div style={{ display: "flex", marginBottom: "2rem" }}>
              <InfoOutlined color="primary" fontSize="large" />
              <Typography variant="h3" marginLeft={"1rem"}>
                ¿Qué incluye?
              </Typography>
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: sortedProducts[selectedVoucherIndex].description,
              }}
            />
          </Grid>
        )}
        <Grid
          item
          alignItems="center"
          gap={2}
          sm={8}
          md={8}
          lg={4}
          textAlign="start"
        >
          <div style={{ display: "flex" }}>
            <HelpOutlineOutlined color="primary" fontSize="large" />
            <Typography variant="h3" marginBottom="2rem" marginLeft={"1rem"}>
              ¿Cómo funciona?
            </Typography>
          </div>
          <Grid container spacing={4} direction={"column"}>
            <Grid
              item
              display="flex"
              alignItems="center"
              gap={2}
              sm={12}
              textAlign="start"
            >
              <SvgIcon
                component={NotificationIcon}
                inheritViewBox
                sx={{ fontSize: "40px" }}
              />
              <Typography variant="body1">
                Elige lo que deseas enviarle a tu ser querido de marcas
                reconocidas.
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              alignItems="center"
              gap={2}
              sm={12}
              textAlign="start"
            >
              <SvgIcon
                component={TicketIcon}
                inheritViewBox
                sx={{ fontSize: "40px" }}
              />
              <Typography variant="body1">
                Paga con tarjeta de crédito o débito a través de Ecosistema Bi.
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              alignItems="center"
              gap={2}
              sm={12}
              textAlign="start"
            >
              <SvgIcon
                component={HeartIcon}
                inheritViewBox
                sx={{ fontSize: "40px" }}
              />
              <Typography variant="body1">
                Enviamos el vale a tus seres queridos por ti por mensaje de
                texto o correo electrónico.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
